import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  Users,
  Baby,
  Calendar,
  Video,
  Clock,
  CheckCircle2,
  ArrowRight,
} from "lucide-react";
import { Button } from "../components/ui/button";

const items = [
  {
    icon: Brain,
    title: "Psicoterapia individual",
    desc: "Atendimentos presenciais ou online com psicólogos parceiros a valores especiais.",
  },
  {
    icon: Users,
    title: "Terapia de casal e familiar",
    desc: "Suporte para fortalecer vínculos e atravessar fases importantes da vida.",
  },
  {
    icon: Baby,
    title: "Atendimento infantil e adolescente",
    desc: "Profissionais especializados em cada fase do desenvolvimento.",
  },
  {
    icon: HeartPulse,
    title: "Psicologia para idosos",
    desc: "Cuidado emocional dedicado à terceira idade, com empatia e escuta ativa.",
  },
  {
    icon: Video,
    title: "Teleatendimento",
    desc: "Sessões online para quem precisa de flexibilidade e conforto.",
  },
  {
    icon: Calendar,
    title: "Agendamento facilitado",
    desc: "Marque consultas direto com os profissionais parceiros.",
  },
];

export default function Beneficios() {
  return (
    <div data-testid="benefits-page">
      <section className="relative">
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#F0FDF4] via-white to-white" />
        <div className="max-w-7xl mx-auto px-5 md:px-8 pt-14 md:pt-20 pb-10 grid md:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-[#166534]/15 bg-[#F0FDF4] text-[#166534] text-xs font-semibold px-3 py-1.5">
              Benefícios & Serviços
            </span>
            <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.02]">
              Psicologia para <br />
              <span className="text-[#166534]">cada fase da vida.</span>
            </h1>
            <p className="mt-5 text-neutral-700 max-w-xl leading-relaxed">
              Como associado, você acessa psicólogos parceiros com valores negociados. O programa
              viabiliza o cuidado — as consultas são pagas diretamente aos profissionais.
            </p>
          </div>

          <div className="rounded-[28px] overflow-hidden border border-neutral-200 shadow-xl shadow-[#166534]/10">
            <img
              src="https://images.unsplash.com/photo-1758273241078-8eec353836be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx0aGVyYXBpc3QlMjBsaXN0ZW5pbmclMjBwYXRpZW50fGVufDB8fHx8MTc5MjI0MjY5N3ww&ixlib=rb-4.1.0&q=85"
              alt="Sessão de terapia"
              className="w-full h-full object-cover aspect-[5/4]"
            />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-16">
        <div className="grid md:grid-cols-3 gap-4">
          {items.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="rounded-2xl border border-neutral-200 bg-white p-6 hover:-translate-y-1 transition-transform"
              data-testid={`benefit-${title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[#F0FDF4] text-[#166534]">
                <Icon className="w-5 h-5" />
              </span>
              <h3 className="font-display mt-4 text-xl font-bold">{title}</h3>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-16">
        <div className="rounded-3xl bg-[#052E16] text-white p-8 md:p-14 grid md:grid-cols-2 gap-10">
          <div>
            <Clock className="w-7 h-7 text-emerald-300" />
            <h2 className="font-display mt-4 text-2xl sm:text-3xl font-extrabold tracking-tight">
              Como funciona o acesso aos benefícios
            </h2>
            <p className="mt-4 text-emerald-100/90 leading-relaxed">
              Após sua adesão aprovada e com a mensalidade em dia, você identifica-se como
              associado ao agendar a consulta. O valor especial é aplicado diretamente.
            </p>
            <Link to="/adesao">
              <Button
                data-testid="benefits-cta-signup"
                className="mt-6 rounded-full bg-white text-[#052E16] hover:bg-emerald-50 hover:text-[#052E16] px-6 h-11"
              >
                Começar adesão
                <ArrowRight className="ml-1 w-4 h-4" />
              </Button>
            </Link>
          </div>
          <ul className="space-y-3">
            {[
              "Mensalidade de R$ 30,00 — família inteira cadastrada no mesmo plano",
              "Valores especiais em consultas particulares com psicólogos parceiros",
              "As consultas são cobradas separadamente (não há cobertura)",
              "Atendimentos presenciais e online",
            ].map((b) => (
              <li key={b} className="flex items-start gap-3 text-emerald-50">
                <CheckCircle2 className="w-5 h-5 text-emerald-300 mt-0.5 shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
